// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: '33cbb323', builtAt: '2026-11-02 18:21 UTC' };
